<script>
export default {
  name: "PersonalDocs"
}
</script>

<template>
  <div class="wrapper-content">
    <h1>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h1>
    <div class="company-name">Общества с ограниченной ответственностью «Бизнес Аренда»</div>

    <h2>1. ОПЕРАТОР И ЕГО ДАННЫЕ</h2>
    <p>1.1. Настоящая Политика обработки персональных данных (далее – Политика) разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных оператором – ООО «Бизнес Аренда» (ИНН 9714029474 ОГРН 1237700890239). Обработка персональных данных осуществляется при использовании сайта <a href="https://rented77.ru">https://rented77.ru</a> (далее – Сайт), а также при непосредственном предоставлении данных субъектами в устной или письменной форме.</p>

    <p>1.2. Правовыми основаниями обработки персональных данных являются:</p>
    <ul>
      <li>законодательство Российской Федерации;</li>
      <li>локальные нормативные акты Компании;</li>
      <li>договоры с субъектами персональных данных;</li>
      <li>согласия субъектов на обработку персональных данных.</li>
    </ul>

    <p>1.3. Термины, используемые в Политике, соответствуют определениям, приведенным в ст. 3 Федерального закона от 27.07.2006 № 152-ФЗ.</p>

    <p>1.4. Обработка персональных данных осуществляется с соблюдением конфиденциальности. Компания не передает персональные данные третьим лицам без согласия субъекта, за исключением случаев, предусмотренных законодательством РФ.</p>

    <h2>2. ПРАВА И ОБЯЗАННОСТИ ОПЕРАТОРА И СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
    <h3>2.1. Права Компании:</h3>
    <ul>
      <li>запрашивать у субъекта достоверные персональные данные;</li>
      <li>требовать своевременного обновления предоставленных данных;</li>
      <li>передавать данные третьим лицам для исполнения договоров;</li>
      <li>размещать фотографии участников мероприятий на Сайте.</li>
    </ul>

    <h3>2.2. Обязанности Компании:</h3>
    <ul>
      <li>обрабатывать данные в соответствии с законодательством РФ;</li>
      <li>отвечать на запросы субъектов в течение 10 рабочих дней;</li>
      <li>предоставлять субъекту доступ к его персональным данным;</li>
      <li>уничтожать данные по обоснованному требованию;</li>
      <li>обеспечивать защиту персональных данных.</li>
    </ul>

    <h3>2.3. Права субъектов персональных данных:</h3>
    <ul>
      <li>получать информацию об обработке своих данных;</li>
      <li>требовать уточнения, блокировки или удаления данных;</li>
      <li>отзывать согласие на обработку;</li>
      <li>иные права, предусмотренные законодательством РФ.</li>
    </ul>

    <h3>2.4. Обязанности субъектов:</h3>
    <ul>
      <li>предоставлять достоверные данные;</li>
      <li>своевременно сообщать об изменениях персональных данных.</li>
    </ul>

    <h2>3. КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ДАННЫХ</h2>
    <p>3.1. Компания обрабатывает персональные данные:</p>
    <ul>
      <li>пользователей Сайта (зарегистрированных и незарегистрированных);</li>
      <li>участников мероприятий;</li>
      <li>клиентов и контрагентов;</li>
      <li>работников и кандидатов на трудоустройство.</li>
    </ul>

    <p>3.2. Перечень обрабатываемых данных включает, но не ограничивается:</p>
    <ul>
      <li>ФИО, контактные данные, паспортные сведения;</li>
      <li>информация о месте жительства, регистрации;</li>
      <li>данные о трудовой деятельности, образовании;</li>
      <li>фото- и видеоматериалы с мероприятий.</li>
    </ul>

    <h2>4. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
    <h3>4.1. Для незарегистрированных пользователей:</h3>
    <ul>
      <li>коммуникация, информирование о деятельности Компании;</li>
      <li>маркетинговые и рекламные рассылки.</li>
    </ul>

    <h3>4.2. Для зарегистрированных пользователей:</h3>
    <ul>
      <li>предоставление доступа к услугам Сайта;</li>
      <li>заключение и исполнение договоров;</li>
      <li>улучшение пользовательского опыта.</li>
    </ul>

    <h3>4.3. Для работников и кандидатов:</h3>
    <ul>
      <li>соблюдение трудового законодательства;</li>
      <li>кадровый учет, пропускной режим.</li>
    </ul>

    <h3>4.4. Для клиентов и контрагентов:</h3>
    <ul>
      <li>исполнение договорных обязательств;</li>
      <li>бухгалтерский и налоговый учет.</li>
    </ul>

    <h2>5. ПОРЯДОК ОБРАБОТКИ И ПЕРЕДАЧИ ДАННЫХ</h2>
    <p>5.1. Обработка включает сбор, хранение, систематизацию, уточнение, передачу и уничтожение данных.</p>

    <p>5.2. Передача данных третьим лицам осуществляется только для исполнения договоров или по требованию закона.</p>

    <p>5.3. Срок хранения данных – до отзыва согласия субъектом или в соответствии с законодательством.</p>

    <h2>6. ЗАЩИТА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
    <p>6.1. Компания принимает необходимые организационные и технические меры для защиты данных.</p>

    <p>6.2. Компания не несет ответственности за несанкционированный доступ к данным, вызванный действиями субъекта.</p>

    <h2>7. СОГЛАСИЕ НА ОБРАБОТКУ</h2>
    <p>7.1. Использование Сайта означает согласие с условиями Политики.</p>

    <p>7.2. Субъект вправе отозвать согласие, направив письменный запрос на контакты, указанные на Сайте.</p>

    <h2>8. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h2>
    <p>8.1. Компания использует файлы cookie и аналогичные технологии для анализа посещаемости Сайта.</p>

    <p>8.2. Трансграничная передача данных не осуществляется.</p>

    <p>8.3. Политика может быть изменена. Актуальная версия всегда доступна на Сайте.</p>

    <div class="version">Редакция от 01.04.24</div>
  </div>
</template>

<style scoped>
  .wrapper-content{
    width: calc(100% - 18.968rem * 2);
    padding: 0 18.968rem;
  }

  @media only screen and (max-width: 700px) {
    .wrapper-content{
      width: calc(100% - 10rem);
      padding: 5rem 5rem 5rem 5rem;
    }
  }
  .document-container {
    background-color: white;
    padding: 4.839rem;
    box-shadow: 0 0 1.935rem rgba(0,0,0,0.05);
    border-radius: 0.774rem;
  }
  h1 {
    text-align: center;
    color: #2c3e50;
    margin-bottom: 3.871rem;
    font-weight: 600;
    font-size: 2.71rem;
  }
  h2 {
    color: #2c3e50;
    margin-top: 4.839rem;
    margin-bottom: 1.935rem;
    font-weight: 600;
    font-size: 2.129rem;
    position: relative;
    padding-left: 1.452rem;
  }
  h2:before {
    content: "";
    position: absolute;
    left: 0;
    top: calc(50% - 1.935rem / 2);
    height: 1.935rem;
    width: 0.484rem;
    background-color: #3498db;
    border-radius: 0.29rem;
  }
  h3 {
    color: #34495e;
    margin-top: 2.903rem;
    margin-bottom: 1.452rem;
    font-weight: 500;
    font-size: 1.742rem;
  }
  .company-name {
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    color: #7f8c8d;
    font-size: 18px;
  }
  .version {
    text-align: right;
    font-style: italic;
    color: #95a5a6;
    margin-top: 60px;
    font-size: 14px;
  }
  ul {
    padding-left: 30px;
    margin: 15px 0;
  }
  li {
    margin-bottom: 12px;
    position: relative;
    padding-left: 15px;
  }
  li:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #3498db;
    font-weight: bold;
  }
  p {
    margin: 1.452rem 0;
  }
  a {
    color: #3498db;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
</style>